import contact from "./contact.json";
import search from "./search.json";
import home from "./home.json";

export default {
  contact,
  search,
  home,
};
